import React from 'react';

function FoodBanking(props) {
    return (
        <div>
            <p>
                The depths of Agriculture roots reside not only in Sri Lanka but spreads
                worldwide. The most popular topic that’s being circulating around the world
                related to Agriculture is the concept of physical Food Banks. Although Agriculture is not new to Sri Lanka, they have not yet adapted to the Food Banking
                concept inside the country. The main idea behind this appreciable conception is
                to minimize the wastage that occur when there is a food surplus that could be
                used otherwise. This challenge could be overcome if the food surplus could be
                distributed among the people with the highest demand in an effective method.
                We are addressing the post-harvest issue of farmers by introducing the food banking
                concept through our application, where the food excess can be dispersed among the people with the
                highest demand in an effective manner.
            </p>
            <br/>
            <br/>

        </div>
    );
}

export default FoodBanking;
